export default __webpack_public_path__ + "static/media/4.9e490633.png";